import { LayerInfo } from "../../../interfaces/resourceInfo";
import { ConfigDataSource } from "../types";

export const getLayerInfoFromDataSources = (
  layerInfos: LayerInfo[],
  dataSources: ConfigDataSource[],
  relatedDataSource: string,
): LayerInfo | undefined =>
  layerInfos?.find(({ name }) => name === dataSources?.find(item => item.name === relatedDataSource)?.layerName);
